
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import AboutSection from './components/AboutSection';
import ProcessSection from './components/ProcessSection';
import ValuesSection from './components/ValuesSection';
import PartnersSection from './components/PartnersSection';

const EmpresaPage = () => {
  useEffect(() => {
    document.title = 'Nuestra Empresa - Especialistas en Vaciado y Limpieza | JUSTCLEAN Castelldefels';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Conoce JUSTCLEAN Castelldefels: más de 15 años de experiencia en vaciado de pisos, locales y limpieza extrema. Equipo profesional, servicio discreto y garantía total.');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Nuestra Empresa - JUSTCLEAN Castelldefels",
      "description": "Conoce JUSTCLEAN Castelldefels: más de 15 años de experiencia en vaciado de pisos, locales y limpieza extrema. Equipo profesional, servicio discreto y garantía total.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://castelldefels.justclean.es'}/empresa`,
      "mainEntity": {
        "@type": "Organization",
        "name": "JUSTCLEAN CASTELLDEFELS",
        "description": "Empresa especializada en vaciado de pisos, locales y limpieza por síndrome de Diógenes en Castelldefels",
        "foundingDate": "2009",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Castelldefels",
          "addressRegion": "Barcelona",
          "addressCountry": "ES"
        },
        "telephone": "+34602365996",
        "email": "info@castelldefels.justclean.es"
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20">
        <AboutSection />
        <ValuesSection />
        <ProcessSection />
        <PartnersSection />
      </div>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default EmpresaPage;
